import { debounce } from "../video-quality/actions";

const controlStrip = $('#tool-box');
const HIDE_TIMEOUTMS = 5000;
let hideDisabled = false;
let controlStripLocked = false;
let stripHideTimeout = 0;
export const hideControlStrip=()=>{
    if(controlStripLocked){
        return;
    }
    controlStrip.removeClass('strip-shown').addClass('strip-hidden');
    $("#videoSpace").removeClass("control-strip")
    $("#arrowIconControlStrip").removeClass("arrow-down")
    $("#arrowIconControlStrip").addClass("arrow-up")
}
export const showControlStrip=(withTimeout=true)=>{
    withTimeout && startStripHideTimeout();
    if(isControlsVisible()){return}
    controlStrip.removeClass('strip-hidden').addClass('strip-shown');
    $("#videoSpace").addClass("control-strip")
    $("#arrowIconControlStrip").addClass("arrow-down")
    $("#arrowIconControlStrip").removeClass("arrow-up")
}
export const showControlStripDebounce=debounce(showControlStrip,500);

export const isControlsVisible=()=>{
    return controlStrip.hasClass('strip-shown')
}

const startStripHideTimeout=()=>{
    clearTimeout(stripHideTimeout);
    stripHideTimeout = setTimeout(() => {
        // hideControlStrip();
    }, HIDE_TIMEOUTMS);
}

export const controlStripOnMouseMove=(e)=>{
    showControlStrip(!hideDisabled);
}

export const allowControlClosing=debounce(()=>{
    hideDisabled = false;
    console.log("Allow from closing")
    startStripHideTimeout();
},500)

export const preventControlFromClosing=debounce(()=>{
    console.log("Prevent from closing")
    clearTimeout(stripHideTimeout);
    hideDisabled = true;
    showControlStrip(false);
},500)

export const lockControlFromClosing = () =>{
    console.log("Lock from closing")
    clearTimeout(stripHideTimeout);
    controlStripLocked=true
    showControlStrip(false);
}

export const unlockControlFromClosing = () =>{
    console.log("Unlock from closing")
    clearTimeout(stripHideTimeout);
    controlStripLocked=false
    allowControlClosing()
}


